export var RESET_IMPRESSONS = 'RESET_IMPRESSONS';
export var PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW = 'PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW'; // From redux-simple-router

export var UPDATE_PATH = '@@router/UPDATE_PATH'; // react-router-redux v3

export var LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // react-router-redux v4

export var UPDATE_HISTORY = '@@router/CALL_HISTORY_METHOD';